<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-2 pt-3">
        <div class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              v-model="perPage"
              size="md"
              :options="pageOptions"
              v-on:change="onChangePageSize"
            ></b-form-select
            >&nbsp;entries
          </label>
        </div>
      </div>
      <div class="col-10 text-right p-2">
        <form class="mt-4 mt-sm-0 float-sm-right form-inline">
          <div class="search-box mr-2 ">
            <div class="position-relative">
              <b-dropdown toggle-class="nav-btn" right variant="primary">
                <template v-slot:button-content>
                  <i class="bx bx-loader bx-spin" v-if="loadingFilter"></i>
                  <i class="bx bx-filter-alt" v-if="!loadingFilter"></i>
                </template>
                <b-dropdown-item v-for="cat in category" :key="cat.id_category"
                  ><span
                    class="btn-block"
                    @click="filterCategory(cat.id_category)"
                    >{{ cat.category_name }}</span
                  ></b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </form>
        <form class="mt-4 mt-sm-0 float-sm-right form-inline ">
          <div class="search-box mr-2 ">
            <div class="position-relative ">
              <input
                type="text"
                class="form-control border-0 rounded"
                v-model="search_data"
                v-on:input="searchProject"
                placeholder="Search..."
              />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-3"
        v-if="user_type !== 'manager'"
      >
        <router-link to="/project/template">
          <div class="card h-100">
            <div class="card-body text-center">
              <i class="fas fa-user-plus text-secondary fa-3x mt-3 py-3"></i>
              <h3 class="text-center mb-5">
                {{ $t("profile.add-profile.text") }}
              </h3>
            </div>
          </div>
        </router-link>
      </div>
      <div
        v-for="target in pageOfItems"
        :key="target.id_target"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-3"
      >
        <router-link :to="'project/project-overview/' + target.id_target">
          <div class="card h-100">
            <div class="card-body">
              <div class="media mb-2">
                <div class="avatar-md mr-4">
                  <img
                    :src="urlimage + target.image_project"
                    class="avatar-title bg-light rounded-circle mb-2"
                    alt
                    height="30"
                  />
                  <span class="ml-1"
                    ><i class="bx bx-target-lock"></i>
                    <span class="py-2 font-weight-bolder"
                      >{{
                        target.category_score ? target.category_score : 0
                      }}/100</span
                    ></span
                  >
                </div>
                <div class="media-body overflow-hidden">
                  <h5 class="text-truncate font-size-15">
                    <a href="#" class="text-dark">{{ target.title }}</a>
                  </h5>
                  <p class="text-truncate text-muted mb-1">
                    {{ target.description }}
                  </p>
                  <div class="team">
                    <a
                      href="javascript: void(0);"
                      class="team-member d-inline-block"
                      v-for="(relation, index) in JSON.parse(
                        '[' + target.relation_profile + ']'
                      )"
                      :key="index"
                    >
                      <router-link
                        :to="{
                          name: 'project-overview',
                          params: { id: relation.id },
                        }"
                      >
                        <img
                          :title="relation.name"
                          :src="urlimage + relation.image"
                          class="rounded-circle avatar-xs m-1"
                          alt
                        />
                      </router-link>
                    </a>
                  </div>
                </div>
                <div class="">
                  <b-dropdown
                    class="chat-noti-dropdown active"
                    right
                    variant="white"
                  >
                    <template v-slot:button-content>
                      <i class="bx bx-sm bx-dots-vertical-rounded"></i>
                    </template>
                    <b-dropdown-item @click="confirmDelete(target.id_target)">{{
                      $t("button.hapus.text")
                    }}</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div class="px-4 py-3 border-top">
              <div class="row">
                <div class="col-sm-5" v-if="target.category">
                  <span
                    class="badge px-2 py-1 text-white"
                    :style="
                      'background-color: var(--' +
                      target.category.badge_color +
                      ')'
                    "
                    >{{ target.category.category_name }}</span
                  >
                </div>
                <div class="col-sm-7 text-right text-secondary">
                  <i class="bx bx-calendar mr-1"></i
                  ><span> {{ formatDate(target.created_at) }}</span>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-lg-12 mb-5">
        <center>
          <jw-pagination
            ref="paginate"
            :items="dataTarget"
            :pageSize="perPage"
            :labels="labelsPaginate"
            @changePage="onChangePage"
          ></jw-pagination>
        </center>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import TargetService from "@/helpers/target-profile.service";
import Swal from "sweetalert2";
import Vue from "vue";
import appConfig from "@/app.config";
import store from "@/state/store";
import moment from "moment";
import CategoryService from "@/helpers/category.service";
import JwPagination from "jw-vue-pagination";

export default {
  page: {
    title: "Project",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, JwPagination },
  data() {
    return {
      urlimage: process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      target: [],
      category: [],
      search_data: "",
      dataTarget: [],
      pageOfItems: [],
      perPage: 15,
      pageOptions: [15, 40, 55, 75],
      searchKey: "",
      user_type: store.state.authBackend.user.type,
      title: this.$t("overview.project.text"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("overview.project.text"),
          active: true,
        },
      ],
      labelsPaginate: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      loadingFilter: false,
    };
  },
  methods: {
    onChangePageSize() {
      this.$refs.paginate.setPage(1);
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    confirmDelete(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          TargetService.delete(id)
            .then(() => {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Successfully delete project",
                showConfirmButton: false,
                timer: 2000,
              });
              this.getTarget();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    getCategory() {
      CategoryService.list()
        .then((response) => {
          this.category = [];
          const allCat = {
            id_category: 0,
            category_name: "All",
            badge_color: "",
            total_profile: "",
          };
          this.category.push(allCat);
          response.data.data.forEach((val) => {
            const data = {
              id_category: val.id_category,
              category_name: val.category_name,
              badge_color: val.badge_color,
              total_profile: val.total_profile,
            };
            this.category.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTarget() {
      TargetService.getfilterBy("search", this.search_data)
        .then((response) => {
          this.dataTarget = [];
          this.dataTarget = response.data.data;
          this.$refs.paginate.setPage(1);
          this.loadingFilter = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingFilter = false;
        });
    },
    searchProject() {
      this.getTarget();
    },
    filterCategory(value) {
      this.loadingFilter = true;
      if (value == 0) {
        this.getTarget();
      } else {
        TargetService.getfilterBy("category", value)
          .then((response) => {
            this.dataTarget = [];
            this.search_data = "";
            this.dataTarget = response.data.data;
            this.$refs.paginate.setPage(1);
            this.loadingFilter = false;
          })
          .catch((err) => {
            console.log(err);
            this.loadingFilter = false;
          });
      }
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  },
  mounted() {
    this.getTarget();
    this.getCategory();
  },
};
</script>
<style scoped>
</style>